var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoVandewieleTurkeyDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 239.9 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #003382;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M.8,20c1.2,3.9,4.2,7,8,8.4l.6.2V5.8L.8,19.8s0,.2,0,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.3,6.4l-.6-.2v22.8l8.6-14v-.2c-1.2-3.9-4.2-7-8-8.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.6,20.8l.7,2.7.7-2.7,5.3-15h5.4l-8.4,22.8h-6.3L27.6,5.8h5.7l5.3,15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.8,24.4h-9l-1.5,4.3h-5.4l8.3-22.8h6.4l8.4,22.8h-5.7l-1.5-4.3ZM56.3,20.3h6l-2.3-6.6-.7-2.6-.7,2.6-2.3,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.1,5.8h5.7l7.2,12,1.7,3.6-.3-15.6h5.4v22.8h-5.7l-7.2-12-1.7-3.7.3,15.6h-5.4V5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.8,5.8h8.8c7.2,0,11.7,4.3,11.7,11.4s-4.5,11.4-11.7,11.4h-8.8V5.8ZM111.8,17.3c0-4.5-2.3-7.1-6.2-7.1h-3.4v14.1h3.4c3.9,0,6.2-2.6,6.2-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.5,5.8h16.4v4.3h-11v4.8h9.7v4.2h-9.7v5.3h11v4.3h-16.4s0-22.8,0-22.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M156.2,15.5l-.5-2.4-.6,2.4-3.7,13.1h-6l-6.7-22.8h5.7l3.7,15,.6,2.7.6-2.7,4.2-15h4.7l4.2,15,.6,2.7.6-2.7,3.7-15h5.4l-6.7,22.8h-6s-3.7-13.1-3.7-13.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.3,5.8h5.4v22.8h-5.4V5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.6,5.8h16.4v4.3h-11v4.8h9.7v4.2h-9.7v5.3h11v4.3h-16.4V5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M204.1,5.8h5.4v18.5h10v4.4h-15.4V5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222.2,5.8h16.4v4.3h-11v4.8h9.7v4.2h-9.7v5.3h11v4.3h-16.4V5.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.3,40.2h-4.2v-1h9.5v1h-4.2v10.8h-1.2v-10.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M44.1,51.2c-2.9,0-4.6-1.8-4.6-4.7v-7.3h1.2v7.3c0,2.3,1.3,3.7,3.4,3.7s3.4-1.4,3.4-3.7v-7.3h1.2v7.3c0,2.9-1.8,4.7-4.6,4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.4,39.2h4c2.4,0,3.9,1.3,3.9,3.2s-.7,2.4-1.9,2.9c.9.3,1.3,1,1.7,2.2l.9,3.5h-1.2l-.8-3.2c-.4-1.7-1.1-1.9-2.6-1.9h-2.7v5.2h-1.2v-11.8ZM52.5,40.1v4.7h2.8c1.7,0,2.8-.9,2.8-2.4s-1.1-2.3-2.7-2.3h-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62,39.2h1.2v5.7l5.9-5.7h1.5l-6,5.8,6.1,6h-1.6l-5.9-5.8v5.8h-1.2v-11.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.4,39.2h7.8v1h-6.7v4.2h6v1h-6v4.7h6.7v1h-7.8v-11.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.6,46.5l-4.3-7.4h1.3l3,5.2.6,1.1.5-1.1,3.1-5.2h1.3l-4.3,7.4v4.5h-1.2v-4.5Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoVandewieleTurkeyDark);
export default __webpack_public_path__ + "static/media/logo_vandewiele-turkey_dark.c102cdc55d1e60e6d565e90684b0293f.svg";
export { ForwardRef as ReactComponent };